import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteReservation } from 'modules/accommodations/features/reservations/api';

export const useDeleteReservationMutation = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { t } = useTranslation();

  return useMutation(deleteReservation, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS);
      successToast(t('Reservation is successfully deleted'));
    },
    onError: () => errorToast(),
  });
};
